export default class ExceptionalDate {
  static ALL_PROFESSIONALS = 'all_professionals'

  static ALL_OPTION = {
    label: 'Todos',
    value: ExceptionalDate.ALL_PROFESSIONALS
  }

  /**
   * Converte a seleção do MultiSelect nos IDs que a API espera.
   *
   * A opção "Todos" carrega a string 'all_professionals' no lugar do profissional, então
   * ler `.value.id` direto nela gera `undefined` e a data excepcional acaba gravada sem
   * profissional nenhum — o que a torna invisível para toda busca feita por profissional.
   *
   * @param options - As opções do MultiSelect, incluindo a de "Todos".
   * @param selected - As opções escolhidas pelo salão.
   * @returns Os IDs dos profissionais, sem repetições e sem valores vazios.
   */
  static getProfessionalIds = (options, selected) => {
    const isAllSelected = selected.some (option => (
      option.value === ExceptionalDate.ALL_PROFESSIONALS
    ))

    const chosen = isAllSelected
      ? options.filter (option => option.value !== ExceptionalDate.ALL_PROFESSIONALS)
      : selected

    return [...new Set (chosen.map (option => option.value?.id).filter (Boolean))]
  }

  /**
   * Monta a seleção inicial do formulário de edição a partir dos profissionais gravados.
   *
   * Como "Todos" é gravado expandindo a escolha em cada profissional, reabrir a data
   * mostrava a lista inteira de nomes em vez da opção que o salão realmente escolheu.
   *
   * @param options - As opções do MultiSelect, incluindo a de "Todos".
   * @param professionals - Os profissionais vinculados à data excepcional.
   * @returns As opções que devem aparecer selecionadas.
   */
  static getSelectedProfessionals = (options, professionals) => {
    const professionalOptions = options.filter (option => (
      option.value !== ExceptionalDate.ALL_PROFESSIONALS
    ))

    // Datas antigas ficaram sem vínculo nenhum, e nesse caso valem para o salão inteiro
    if (professionals.length === 0) return [ExceptionalDate.ALL_OPTION]

    const selectedIds = new Set (professionals.map (professional => professional.id))

    const coversEveryone = professionalOptions.length > 0 && professionalOptions.every (
      option => selectedIds.has (option.value?.id)
    )

    if (coversEveryone) return [ExceptionalDate.ALL_OPTION]

    // Quem saiu do salão continua vinculado à data, mas não está mais entre as opções
    return professionals.map (professional => (
      professionalOptions.find (option => option.value?.id === professional.id)
      || { label: professional.nickname, value: professional }
    ))
  }

  /**
   * Mantém "Todos" e nomes individuais mutuamente exclusivos na seleção.
   *
   * São duas formas de dizer a mesma coisa, e deixar as duas marcadas ao mesmo tempo
   * mostra uma seleção que não corresponde ao que será gravado.
   *
   * @param name - O nome do campo no Formik.
   * @param selected - As opções escolhidas, com a última sendo a que acabou de entrar.
   * @param setFieldValue - O setter de campo do Formik.
   */
  static handleProfessionalsChange = (name, selected, setFieldValue) => {
    const options = selected ?? []
    const justAdded = options[options.length - 1]

    if (justAdded?.value === ExceptionalDate.ALL_PROFESSIONALS) {
      return setFieldValue (name, [ExceptionalDate.ALL_OPTION])
    }

    setFieldValue (name, options.filter (option => (
      option.value !== ExceptionalDate.ALL_PROFESSIONALS
    )))
  }
}
